import { useState } from "react";

import { mockedBrands } from "./__tests__/mock-data";
import { TAPIResponse } from "../types";
import { API_STATES } from "../helpers";

type TBrand = {
    id: string;
    name: string;
};

export type TBrandsResponse = {
    brands: TBrand[];
};

type TUseFetchBrandsResponse = TAPIResponse<TBrandsResponse, any> & {
    fetch: (params: { brand: string }) => void;
};

export const useFetchBrands = (): TUseFetchBrandsResponse => {
    const [state, setState] = useState<TAPIResponse<TBrandsResponse, string>>(API_STATES.default);
    const APIStates = API_STATES.getStates(setState);

    const fetch = (params: { brand: string }) => {
        if (!params.brand) {
            return;
        }

        APIStates.pending();

        new Promise((res, rej) => {
            res(mockedBrands);
        }).then(APIStates.success);
    };

    return {
        data: state.data,
        error: state.error,
        isLoading: state.isLoading,
        loaded: state.loaded,
        fetch,
    };
};
